import React, { } from 'react';
import JJ_From, { FormItemData } from "../../components/JJ_From";
import api, { PutUserParameters } from '../../api';
import { Select, Tag } from 'antd';
import { connect, ConnectedProps } from 'react-redux';



interface PageState {

}

type Type = { type: 'add' } | { type: 'edit', id: string }

interface Props {
  onFinish?(props: PageProps, id: string): void
}



interface Page {
  /**
   * 保存数据
   */
  _onFinish(values: any): void

  /**
   * 获取数据
   */
  _onLoadData(): Promise<{}>

  id?: string

}


type PageProps = Props & Type & PropsFromRedux

type PropsFromRedux = ConnectedProps<typeof connector>


interface RootState {

}

const mapState = (state: RootState) => ({

})

const mapDispatch = {

}

const connector = connect(
  mapState,
  mapDispatch
)


class UserEditAndAdd extends React.Component<PageProps, PageState> implements Page {

  constructor (props: Readonly<PageProps>) {
    super(props);

    this.state = {

    }

  }
  componentDidMount() {
  }

  _putUser = async (params: PutUserParameters) => {
    const res = await api.PutUser(params)
    if (res.kind !== 'ok') throw new Error(res.kind)
    return res.data
  }

  _onFinish = async (values: any): Promise<void> => {

    switch (this.props.type) {
      case 'edit': {
        const res = await this._putUser({
          ...values,
          id: this.props.id,
        })
        this.props.onFinish && this.props.onFinish(this.props, this.props.id)
      }
        break 
      case 'add': {


      }
        break
    }
  }
  _onLoadData = async (): Promise<any> => {
    switch (this.props.type) {
      case 'edit': {
        const res = await api.GetUser({ id: this.props.id })

        if (res.kind === 'ok') {
          return res.data
        }
        throw Error(res.kind)
      }
      case 'add': {
        return
      }

    }
  };

  _formListData = (): FormItemData[] => {
    switch (this.props.type) {
      case 'edit': {
        return [
          {
            id: 'companyName',
            label: '公司/學校名',
            rules: [
              {
                required: false,
              }
            ],
          },
          {
            id: 'contactPerson',
            label: '聯繫人',
            rules: [
              {
                required: false,
              }
            ],
          },
          {
            id: 'contactNumber',
            label: '聯繫人電話',
            rules: [
              {
                required: false,
              }
            ],
          },
          {
            id: 'locale',
            label: '語言',
            rules: [
              {
                required: false,
              }
            ],

            componet: (
              <Select>
                {
                  [
                    {
                      name: '繁體中文',
                      value: 'zh-tw'
                    },
                    {
                      name: '英文',
                      value: 'en'
                    },
                  ].map((option, index) => {
                    return (
                      <Select.Option key={option.value} value={option.value}>{option.name}</Select.Option>
                    )
                  })}
              </Select>
            )
          },
          {
            id: 'submit',
          },
        ]
      }
      case 'add': {
        return [
          {
            id: 'submit',
          },
        ]
      }

    }
  }

  render() {
    return (
      <div id="UserEditAndAdd">
        <JJ_From
          formListData={this._formListData()}
          onLoadData={this._onLoadData}
          onFinish={this._onFinish}
        />
      </div>
    )
  }

}
export default connector(UserEditAndAdd)
